var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lesson_ic_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lesson_ic_svg__st0{fill:none;stroke:#1d7777;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.1px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lesson_ic_svg__file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lesson_ic_svg__Vector",
    className: "lesson_ic_svg__st0",
    d: "M14.1 2.6H5.7c-.6 0-1.1.2-1.5.6s-.6.9-.6 1.5v16.7c0 .6.2 1.1.6 1.5.4.4.9.6 1.5.6h12.5c.6 0 1.1-.2 1.5-.6s.6-.9.6-1.5V8.9l-6.2-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lesson_ic_svg__Vector_2",
    className: "lesson_ic_svg__st0",
    d: "M14.1 2.6v6.2h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lesson_ic_svg__Vector_3",
    className: "lesson_ic_svg__st0",
    d: "M16.2 14H7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lesson_ic_svg__Vector_4",
    className: "lesson_ic_svg__st0",
    d: "M16.2 18.2H7.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lesson_ic_svg__Vector_5",
    className: "lesson_ic_svg__st0",
    d: "M9.9 9.9H7.8"
  }))));
}
export default SvgLessonIc;